var map = {
	"./cnn-money-x2.png": 2035,
	"./economist-x2.png": 2036,
	"./mashable-x2.png": 2037,
	"./tech-crunch-x2.png": 2038,
	"./thenewyorker-x2.png": 2039,
	"./thrillist-x2.png": 2040,
	"./time-x2.png": 2041,
	"./usa-today-x2.png": 2042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2247;